export interface PageInfo {
  currentPage: number
  totalPages: number
  totalCount: number
}

export interface Label {
  color?: string
  description?: string
  id: number
  name: string
  nameHtml?: string
}

export const DisplayMode = {
  Compact: 'compact',
  Default: 'default',
} as const

export type DisplayMode = (typeof DisplayMode)[keyof typeof DisplayMode]
